var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('fieldset',{staticClass:"lookup-radio",class:_vm.rootClass},[_c('legend',{staticClass:"lookup-radio__label"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('b-radio-group',_vm._g(_vm._b({},'b-radio-group',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }